module.exports = __webpack_public_path__ + "img/W7023-trad.50918220.jpg";